import {RelatedImage, TaskService} from '../../../index';
import {Observable, of} from 'rxjs';
import {Injectable} from '@angular/core';
import {DocumentsApi, TasksApi} from 'twict4fiber-api-web-rest-angular-17';
import {TaskRelatedDocument} from '../../../specification/models/task-related-document.model';

@Injectable({providedIn: 'root'})
export class NetcomTaskService implements TaskService {

  public constructor(private readonly tasksApi: TasksApi,
                     private readonly documentsApi: DocumentsApi) {
  }

  getTaskRelatedDocuments(taskUuid: string): Observable<TaskRelatedDocument[]>{
    //return this.documentsApi.getAllTaskRelatedDocuments(taskUuid);
    return of();
  }

  getRelatedImages(taskUuid: string): Observable<RelatedImage[]> {
    return this.tasksApi.getImagesForTask(taskUuid);
  }

}
